
<span class="help-document-title">Help Documents</span>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
<ng-container *ngIf="!isLoading else loading">
	<div *ngFor="let helpDocument of helpDocuments" class="help-document-item">
		<div class="help-document-item-title">
			<span>{{ getDocumentTitle(helpDocument.files) }}</span>
		</div>
		<a *ngFor="let file of helpDocument.files" class="help-document-item-file-link settings-text-underlined"
			[href]="getURL(file, helpDocument.id) | copoSafeUrl" [type]="file.type"
			(click)="trackDownload(file, helpDocument.id)">
			{{ getLang(file.lang) }}
		</a>
	</div>
</ng-container>
